import { colors, createMuiTheme } from '@material-ui/core';
import { capitalize } from 'lodash';

const lightTheme = createMuiTheme({
  palette: {
    type: 'light',
    common: {
      white: '#fff',
    },
    action: {
      active: colors.blueGrey[600],
    },
    background: {
      default: '#fafafa',
      paper: '#fff',
    },
    primary: {
      light: '#7152F3 ',
      main: '#7152F3',
      dark: '#303f9f',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff4081',
      main: '#7152F3',
      dark: '#c51162',
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
    },
  },
  overrides: {
    MuiFilledInput: {
      root:{
        backgroundColor:'white',
        '&:hover': {
          backgroundColor:'white',
        }
      },
      underline:{
        '&:before': {
          borderBottom: 'inherit'
        },
        '&:hover':{
          '&:before': {
            borderBottom: 'inherit'
          }
        },
        '&:after': {
          borderBottom: 'inherit'
        }
      },
      input: {
        border: '1px solid #7152F3',
        borderRadius: '10px !important',
        '&:focus': {
          backgroundColor:'white',
        },
      }
    },    
    MuiPaper: {
      root:{
        backgroundColor: 'white !important'
      }
    },
    //MuiButtonBase-root-MuiTab-root.Mui-selected
    MuiTabs: {
      indicator: {
        backgroundColor: '#7152F3'
      }
    },
    MuiInputLabel: {
      focused: {
        color: 'red', // Change this to your desired color
      },
    },
   
  },
});

export default lightTheme;
